import { TextField, FormControl, FormLabel } from "@mui/material";
import { FieldError, UseFormRegisterReturn } from "react-hook-form";

const FormTextField = ({
  register,
  error,
  label,
}: {
  register?: UseFormRegisterReturn;
  error?: FieldError;
  label: string;
}) => {
  return (
    <FormControl
      sx={{
        display: "flex",
        flexDirection: "column",
        rowGap: "6px",
      }}
      error={!!error}
    >
      <FormLabel
        sx={{
          color: "#344054",
          fontFamily: "Montserrat",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "20px",
        }}
      >
        {label}
      </FormLabel>
      <TextField {...register} error={!!error} helperText={error?.message} />
    </FormControl>
  );
};

export default FormTextField;
